import React from 'react';

import DropdownBox from 'craft/containers/Toolbox/components/DropdownBox';
import { useMultiNodes } from 'craft/hooks';
import { useEnum } from 'craft/state';
import { EnumFieldType, PropToEdit } from 'craft/types';

interface Props {
  nodeIds: string[];
  propToEdit: PropToEdit<EnumFieldType>;
}

const EnumField = ({ nodeIds, propToEdit }: Props) => {
  const {
    actions: { setProps },
  } = useMultiNodes(nodeIds);
  const { schema, value: currentValue } = propToEdit;
  const { enumId } = schema.fieldType;
  const enumSchema = useEnum(enumId);

  const selectedOption = currentValue || schema.fieldType.defaultValue || enumSchema?.defaultValue;

  const onChange = (value: any) => {
    setProps({ [schema.id]: value });
  };

  return (
    <DropdownBox
      value={selectedOption}
      onChange={onChange}
      options={enumSchema?.values ?? []}
      label={schema.name ?? enumSchema?.id}
      trackingId={schema.name}
    />
  );
};

export default EnumField;
